import storage from 'good-storage'
import http from '../lib/http'
import {loginInfoCache} from "../lib/cache/LoginInfo"
import {getENV, isEmpty} from "../lib/utils";
import {loginTeamCache} from "@/common/lib/cache/LoginTeam";


export default {
    install(Vue) {
        /*添加实例属性*/
        Vue.prototype.$http = http;
        Vue.prototype.$cache = storage.session;
        Vue.prototype.$storage = storage;
        Vue.prototype.$env = {...process.env, ...getENV()};


        /*全局Mixin*/
        Vue.mixin({
            data() {
                return {
                    env: {...process.env, ...getENV(), printCss: ''},
                    loadingQueued: [],
                    appShowLoading: false,
                    loginInfo: {},
                    loginTeam: {}
                }
            },
            computed: {
                requestLoading() {
                    return this.$store.state.requestLoading;
                },
                meta() {
                    return this.$route && this.$route.meta;
                },
                hasLogin() {
                    return !isEmpty(this.loginInfo);
                },
                healthcheckBookTeam() {
                    return this.loginTeam;
                    //const {loginInfo} = this;
                    //return loginInfo && loginInfo.healthcheckBookTeam ? loginInfo.healthcheckBookTeam : {};
                },
                docInfo() {
                    const {loginInfo} = this;
                    return loginInfo && loginInfo.doc ? loginInfo.doc : {};
                },
                staffType() {
                    return this.loginInfo.staffType
                },
                isAID_E_ADM() {
                    return this.staffType === 'AID_E_ADM';
                },
                isAID_ADM() {
                    return this.staffType === 'AID_ADM';
                }
            },
            async created() {
                const {env} = this;
                let baseUrl = env.PUBLIC_PATH || env.BASE_URL || '/';
                if (baseUrl === '/') baseUrl = '';
                this.$set(this.env, 'printCss', `${baseUrl}/css/print.css`)
                this.loginInfo = loginInfoCache.get() || {};
                this.loginTeam = loginTeamCache.get() || {};
                bus.$on('loading', (res) => {
                    if (res !== false) {
                        this.appShowLoading = true;
                        this.loadingQueued.push(new Date());
                    } else {
                        this.loadingQueued.shift();
                        if (this.loadingQueued.length === 0) this.appShowLoading = false;
                    }
                })
            },
            methods: {}
        })
    }
}
